import type { RouteRecordRaw } from 'vue-router'
import ROUTES from './routes'

export default function (): RouteRecordRaw[] {
  if (!import.meta.env.DEV) return []

  return [
    {
      path: 'dev-tools',
      name: ROUTES.DEV_TOOLS,
      // Lazy import — this dynamic expression is dead code in production builds
      // (import.meta.env.DEV === false at build time, so this function never returns it).
      // Rollup never emits the chunk; DevToolsView.vue is absent from dist/.
      component: async () => await import('@/views/DevToolsView.vue'),
      meta: {
        resetBreadcrumb: true,
        breadcrumb: {
          name: ROUTES.DEV_TOOLS,
          text: 'Dev Tools'
        }
      }
    }
  ]
}
